import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { clearSession, getBearer, refresh } from '@core/auth/kc-tokens';
import { ROUTES } from '../../app.routes';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  const bearer = getBearer();
  const authedReq = bearer
    ? req.clone({ setHeaders: { Authorization: `Bearer ${bearer}` } })
    : req;

  return next(authedReq).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status !== 401) {
        return throwError(() => err);
      }
      // No session to refresh (e.g. guest hitting a secured endpoint) — surface the 401
      // rather than bouncing to login.
      if (!getBearer()) {
        return throwError(() => err);
      }
      return from(refresh()).pipe(
        switchMap((ok) => {
          if (!ok) {
            clearSession();
            void router.navigate([ROUTES.login], { queryParams: { returnTo: router.url } });
            return throwError(() => err);
          }
          const freshBearer = getBearer();
          const retryReq = freshBearer
            ? req.clone({ setHeaders: { Authorization: `Bearer ${freshBearer}` } })
            : req;
          return next(retryReq);
        }),
      );
    }),
  );
};
